export default __webpack_public_path__ + "static/media/mp.038ceef9.jpg";